import { Button, Card } from "react-bootstrap";
import React, { Component, View } from "react";
import PopupButton from "./PopupButton";
import styled from "styled-components";
import colors from "../config/colors";

const Box = styled.div`
  font-size: 0.1em;
  margin: 3em;
  zoom: 1;
  padding: 2em;
  border-radius: 13px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  height: 30px;
  background: ${colors.hashTagBgColor};
  border: 0px solid ${colors.hashTagBgColor};
`;

const Content = styled.p`
  font-size: 15px;
  color: ${colors.hashTagTextColor};
  text-align: center;
`;

const styles = {
  card: {
    backgroundColor: "white",
    borderRadius: 10,
    padding: "3rem",
  },
  cardImage: {
    objectFit: "contain",
    borderRadius: 10,
    // width: "10vw",
    // height: "10vh",
    width: "100%",
    maxHeight: "8vh",
  },
};

class ProjectCard extends Component {
  render() {
    return (
      <Card className="m-2 border-0 shadow" style={styles.card}>
        <Card.Img src={this.props.imageUrl} style={styles.cardImage} />
        <Card.Body>
          <Card.Title>{this.props.title}</Card.Title>

          <Card.Text>{this.props.bodyText}</Card.Text>
          {this.props.hashTags.map((item) => (
            <Box>
              <Content>{item.toString()}</Content>
            </Box>
          ))}

          <PopupButton popupContent={this.props.popupContent} />
        </Card.Body>
      </Card>
    );
  }
}

export default ProjectCard;
